import * as actionTypes from '../actions/types';
import { LAYOVER_USER } from '../constants';
import { PER_PAGE } from '../helpers/actions';

const initialState = {
  subsWithoutLayover: [],
  subsWithoutLayoverPageCount: 0,
};

const allSubs = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_CARRIERS_SUBS_WITHOUT_LAYOVER: {
      let newSubs = action.payload || [];

      newSubs = newSubs.filter((sub) => sub.user_profile !== LAYOVER_USER);
      const subsDivPerPage = newSubs.length / PER_PAGE;
      const pageCount =
        parseInt(subsDivPerPage, 10) === subsDivPerPage
          ? subsDivPerPage
          : parseInt(subsDivPerPage, 10) + 1;

      return {
        ...state,
        subsWithoutLayover: newSubs,
        subsWithoutLayoverPageCount: pageCount,
      };
    }
    case actionTypes.GET_ALL_USER_SUBS: {
      return {
        ...state,
        [`userSubs${action.userId}`]: action.payload,
      };
    }
    default:
      return state;
  }
};
export default allSubs;

export const getAllUserSubs = (state, userId) => state[`userSubs${userId}`];
export const getAllCarriersSubsWithoutLayover = (state, page = 1) =>
  state.subsWithoutLayover.slice(PER_PAGE * (page - 1), PER_PAGE * page);
export const getAllCarriersSubsWithoutLayoverPageCount = (state) =>
  state.subsWithoutLayoverPageCount;
